/**
 * Quantity rounded up
 * @param { String, Number } val value
 * @param { String, Number} bit Keep several decimal places, default 2
 */
/**
 * 数量向上取整
 * @param { String, Number } val 值
 * @param { String, Number} bit 保留几位小数，默认 2
 */
const _numberUpFixed = function (val, bit = 2) {
  const num = Math.pow(10, bit)
  return (Math.ceil(Math.round(Number(val) * num)) / num).toFixed(2)
}

/*
 * PHP 7.x round() 的逐行移植（ext/standard/math.c _php_math_round，PHP_ROUND_HALF_UP）。
 * 照搬 frontend-user-2026/docs/plans/2026-09-28-surcharge-audit/fixtures/php_round_port.cjs（2026-09-28 与本机
 * PHP 7.4.33 对拍 600,016 个值 0 处不一致）。不要改写成「更简洁」的等价式 —— 等价与否只有对拍说了算。
 *
 * 关键：PHP 先按 value **自身**的数量级把它预取整到 15 位有效数字（14 - floor(log10|value|) 位），再缩放到目标位；
 * 不是先 ×100 再预取整。上一版 `Number((x*100).toPrecision(15))` 就错在这里，同一批值里错 7 处
 * （0.7749999999999995 → PHP 0.78 / 旧 0.77；9.0449999999999946 → 9.05 / 9.04；0.0049999999999999975 → 0 / 0.01）。
 * ⚠️ 只对 PHP 7.x / 8.0–8.3 成立；PHP 8.4 改了 round()（去掉预取整），后端升级 PHP 时要重新对拍
 * （tests/unit/fixtures/surcharge/php-round-port-cases.json）。
 */
function roundHelper(v) {
  return v >= 0.0 ? Math.floor(v + 0.5) : Math.ceil(v - 0.5)
}
function intpow10(p) {
  return p < 0 || p > 22 ? Math.pow(10, p) : Number('1e' + p)
}
function phpRound(value, places) {
  if (!Number.isFinite(value) || value === 0) return value
  const precisionPlaces = 14 - Math.floor(Math.log10(Math.abs(value)))
  const f1 = intpow10(Math.abs(places))
  let tmp
  if (precisionPlaces > places && precisionPlaces - 15 < places) {
    let usePrecision = precisionPlaces < -60 ? -60 : precisionPlaces
    const f2 = intpow10(Math.abs(usePrecision))
    tmp = roundHelper(usePrecision >= 0 ? value * f2 : value / f2)
    usePrecision = Math.max(-60, places - usePrecision)
    tmp = tmp / intpow10(Math.abs(usePrecision))
  } else {
    tmp = places >= 0 ? value * f1 : value / f1
    if (Math.abs(tmp) >= 1e15) return value
  }
  tmp = roundHelper(tmp)
  return places > 0 ? tmp / f1 : tmp * f1
}

/**
 * PHP 7.4 `round($x, 2)`，逐位一致（审计 00-backend-spec §0 / §6.3）。非数字按 0。
 * 与后端对钱时只在后端调 round() 的地方用它：utils/feeChain.js 的 SUR / A3 / FEE / A5、小费 tipAmountFor，
 * 以及多店「各家已取整的金额求和后去浮点噪声」。后端不取整的地方（整单券额、配送费、小计）不要随手取。
 * @param {number|string} x
 * @returns {number}
 */
const _phpRound2 = function (x) {
  const n = Number(x)
  if (!Number.isFinite(n)) return 0
  return phpRound(n, 2)
}

export {
  _numberUpFixed,
  _phpRound2
}
